export default "__VITE_ASSET__D4G0l2CW__"